module.exports = __webpack_public_path__ + "static/media/image_77.aa84ff99.png";